import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../components/Card';
import Button from '../components/Button';

const NotFoundPage: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-8">
            <Card variant="elevated">
                <Card.Header 
                    title="404 - Page Not Found" 
                    subtitle="The page you're looking for doesn't exist"
                />
                <Card.Body>
                    <p className="mb-6 text-gray-600 dark:text-gray-400">
                        The URL you entered may be incorrect, or the page may have been moved.
                    </p>
                    <div className="flex gap-4 flex-wrap">
                        <Link to="/">
                            <Button variant="primary">Go to Dashboard</Button>
                        </Link>
                        <Link to="/projects">
                            <Button variant="outline">View Projects</Button>
                        </Link>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default NotFoundPage;
